import { render } from "./LayoutIntegrationSettings.vue?vue&type=template&id=a593f13a"
import script from "./LayoutIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./LayoutIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__